import { useQuizStore } from "../../hooks";

export const QuizProgressBar = () => {
  const { percentage } = useQuizStore();

  return (
    <div
      className="progress position-relative bg-transparent"
      style={{ height: "10px", borderRadius: "10px" }}
    >
      {/* Barra principal */}
      <div
        className="progress-bar bg-purple-500"
        role="progressbar"
        style={{
          width: `${percentage === 100 ? 100 : percentage - 1}%`,
          transition: "width 0.8s ease-in-out",
        }}
      ></div>

      {/* Overlay claro al final */}
      <div
        className="position-absolute top-0 bottom-0 bg-purple-100"
        style={{
          width: `${100 - percentage}%`,
          right: 0,
          marginLeft: "1px",
          borderRadius: "0 10px 10px 0",
          transition: "width 0.8s ease-in-out",
          position: "relative",
        }}
      >
        <span
          style={{
            position: "absolute",
            right: "2px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: "#6f42c1",
          }}
        />
      </div>
    </div>
  );
};
